import React, {useEffect, useState} from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    withStyles
} from '@material-ui/core';
import styles from './styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import {Cancel as CancelIcon, Save as SaveIcon} from '@material-ui/icons';
import {onCloseWithBackdropCurry} from 'services/util/helperFuncs';
import {
    DayOfWeekSelect,
    DropdownSelect,
    DropdownSelectSimple,
} from 'components';
import {
    getModeOptionString,
    GoogleMapsDistanceMatrixModeOption
} from "../../../services/enums/GoolgeMapsDistanceMatrixHelper";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/de";


function CreateTemplateDialog(props) {

    const {classes, t, dialogState, handleCancel, handleClose, templatePreset, shipperOptions} = props;
    const [template, setTemplate] = useState(templatePreset);

    useEffect(() => {
        setTemplate(templatePreset)
    }, [dialogState.open, templatePreset]);

    const dialogOk = () => {
        handleClose(template);
    };

    const handleNotOk = () => {
        handleCancel();
    };
    const handleGoogleMatrixModeChange = (mode) => {
        setTemplate((prev) => ({
            ...prev,
            travelMode: mode
        }))
    }

    const isDepartureTimeValid = template.departureTime >= new Date();

    return (
        <Dialog
            className={classes.dialog}
            disableEscapeKeyDown
            fullWidth
            maxWidth={'sm'}
            onClose={onCloseWithBackdropCurry(handleCancel)}
            open={dialogState.open}
        >
            <DialogTitle>{t('createTourTemplate')}</DialogTitle>
            <DialogContent>
                <form>
                    <div className={classes.rowWrapper}>
                        <TextField
                            className={classes.formControl}
                            label={t('tourTemplateName')}
                            onChange={(e) => setTemplate({...template, templateName: e.target.value})}
                            value={template?.templateName || ''}
                        />
                    </div>
                    <div className={classes.rowWrapper}>
                        <DayOfWeekSelect
                            error={template.dayOfWeek === '' || template.dayOfWeek == null}
                            required
                            setValue={(value) => setTemplate({...template, dayOfWeek: value})}
                            value={template.dayOfWeek || ''}
                        />
                        <DropdownSelectSimple
                            error={!template.shipperName}
                            hideOnEmptyOptions
                            name={t('shipper')}
                            options={shipperOptions}
                            required
                            setValue={(value) => setTemplate({...template, shipperName: value})}
                            sort
                            value={template.shipperName}
                        />
                    </div>

                    <div>
                        <div>
                            <DropdownSelect
                                name={t('modeOption')}
                                options={Object.values(GoogleMapsDistanceMatrixModeOption).map(val => ({
                                    value: val,
                                    name: t(getModeOptionString(val))
                                }))}
                                required
                                setValue={handleGoogleMatrixModeChange}
                                sort
                                value={template.travelMode}
                            />
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                                <DateTimePicker
                                    ampm={false}
                                    label={t('time')}
                                    value={template.departureTime}
                                    format="d. MMMM, HH:mm"
                                    error={!isDepartureTimeValid}
                                    onChange={(value) => {
                                        setTemplate((prev) => ({
                                            ...prev,
                                            departureTime: new Date(value)
                                        }));
                                    }}
                                    className={classes.formControl}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </div>
                </form>
            </DialogContent>
            <DialogActions>
                <Button
                    color="default"
                    onClick={handleNotOk}
                >
                    <CancelIcon/>&nbsp;{t('dialogCancel')}
                </Button>
                <Button
                    color="primary"
                    disabled={!template.shipperName || template.dayOfWeek === ''}
                    onClick={dialogOk}
                >
                    <SaveIcon/>&nbsp;{t('save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

CreateTemplateDialog.propTypes = {
    carrierWithMicroHubs: PropTypes.object,
    classes: PropTypes.object.isRequired,
    dialogState: PropTypes.object.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    shipperOptions: PropTypes.array.isRequired,
    t: PropTypes.func.isRequired,
    templatePreset: PropTypes.object.isRequired
};

export default compose(withStyles(styles), withTranslation())(CreateTemplateDialog);
